// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.note-details {
  background-color: #36f;
  color: #fff;
}

.note-details:hover {
  color: #fff;
  border-color: #598bff;
  background-color: #598bff;
}

.modal-footer-center {
  padding-top: 10px;
  padding-bottom: 10px;
}

.fixTableHead {
  overflow-y: auto;
  overflow-x: hidden;
  height: 150px;
}

.fixTableHead thead th {
  position: sticky;
  top: 0;
}

th {
  top: 0;
  height: 30px;
  text-align: left;
  background: #dbdbdb;
  z-index: 5;
  border: 1px solid #767c80;
}

td {
  text-align: left;
}

.responseDataTable {
  height: 20rem;
  overflow-y: auto;
  overflow-x: hidden;
}

.responseNewDataTable {
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
}

.requiredNotes {
  border: 1px solid red;
}`, "",{"version":3,"sources":["webpack://./src/app/agent/agent-add-note/agent-add-note.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AACF;;AAEA;EACE,iBAAA;EACA,oBAAA;AACF;;AACA;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;AAEF;;AAAA;EACE,gBAAA;EACA,MAAA;AAGF;;AADA;EACE,MAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,yBAAA;AAIF;;AAFA;EACE,gBAAA;AAKF;;AAHA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;AAMF;;AAJA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AAOF;;AALA;EACE,qBAAA;AAQF","sourcesContent":[".note-details {\r\n  background-color: #36f;\r\n  color: #fff;\r\n}\r\n\r\n.note-details:hover {\r\n  color: #fff;\r\n  border-color: #598bff;\r\n  background-color: #598bff;\r\n}\r\n\r\n.modal-footer-center {\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n}\r\n.fixTableHead {\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  height: 150px;\r\n}\r\n.fixTableHead thead th {\r\n  position: sticky;\r\n  top: 0;\r\n}\r\nth {\r\n  top: 0;\r\n  height: 30px;\r\n  text-align: left;\r\n  background: #dbdbdb;\r\n  z-index: 5;\r\n  border: 1px solid #767c80;\r\n}\r\ntd {\r\n  text-align: left;\r\n}\r\n.responseDataTable {\r\n  height: 20rem;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n}\r\n.responseNewDataTable {\r\n  height: auto;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n}\r\n.requiredNotes {\r\n  border: 1px solid red;\r\n}\r\n\r\n// .form-control:disabled,\r\n// .form-control:disabled:hover,\r\n// .form-control:disabled:focus,\r\n// .form-control[readonly],\r\n// .form-control[readonly]:hover,\r\n// .form-control[readonly]:focus,\r\n// select:disabled,\r\n// select:disabled:hover,\r\n// select:disabled:focus {\r\n//   background-color: #fff;\r\n// }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
